const house = [
    {
        path: '/integral/setting',
        name: 'integralSetting',
        component: () => import('@/view/integral/setting'),
    },
]
export default house